import { useState } from "react";
import clsx from "clsx";
import ButtonComplex from "./ButtonComplex";
import ButtonToggle from "./ButtonToggle";

export interface VehicleToggleProps {
  className: string;
  vehicleToggle: boolean;
  setVehicleToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function VehicleToggle({
  className,
  vehicleToggle,
  setVehicleToggle,
}: VehicleToggleProps) {
  return (
    <ButtonComplex label="Vozila u dolasku" className={className}>
      <ButtonToggle
        vehicleToggle={vehicleToggle}
        setVehicleToggle={setVehicleToggle}
      />
    </ButtonComplex>
  );
}

export default VehicleToggle;
